/* eslint-disable sort-keys-fix/sort-keys-fix */
import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';
import { DATE_TIME_ISO_SCHEMA } from '../rxdb.constants';

const questionnaireTemplateSchemaLiteral = {
  title: 'Questionnaire Template',
  version: 0,
  description: 'Schema for questionnaire templates',
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 50 },
    creatorId: { type: 'string' },
    descriptionAST: { type: ['null', 'object'] },
    descriptionHtml: { type: ['null', 'string'] },
    descriptionText: { type: ['null', 'string'] },
    label: { type: 'string' },
    questionnaireAssigneeTemplates: {
      type: 'array',
      items: { type: 'object' },
    },
    sectionTemplates: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          conditionExpression: {
            type: ['null', 'object'],
            properties: {
              createdAt: { type: 'string' },
              deletedAt: { type: ['null', 'string'] },
              expression: { type: 'string' },
              filterExpression: { type: ['null', 'string'] },
              filterExpressionItemSelector: { type: ['null', 'string'] },
              filterExpressionOperand: { type: ['null', 'string'] },
              filterExpressionReducer: { type: ['null', 'string'] },
              filterExpressionVariableName: { type: ['null', 'string'] },
              id: { type: 'string' },
              updatedAt: { type: 'string' },
              variables: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    createdAt: { type: 'string' },
                    deletedAt: { type: ['null', 'string'] },
                    expressionId: { type: 'string' },
                    id: { type: 'string' },
                    referenceId: { type: 'string' },
                    referenceType: { type: 'string' },
                    selector: { type: 'string' },
                    updatedAt: { type: 'string' },
                    variableName: { type: 'string' },
                  },
                },
              },
            },
          },
          descriptionAST: { type: ['null', 'object'] },
          descriptionHtml: { type: ['null', 'string'] },
          descriptionText: { type: ['null', 'string'] },
          id: { type: 'string' },
          key: { type: 'string' },
          label: { type: 'string' },
          pdfTemplateId: { type: ['null', 'string'] },
          questionnaireTemplateId: { type: 'string' },
          rank: { type: 'integer' },
          slug: { type: 'string' },
          subsections: {
            type: ['null', 'array'],
            items: { type: 'string' },
          },
        },
      },
    },
    slug: { type: 'string' },
    status: { type: 'string' },
    createdAt: DATE_TIME_ISO_SCHEMA,
    updatedAt: DATE_TIME_ISO_SCHEMA,
    updatedBy: { type: ['null', 'string'] },
    updatedByName: { type: ['null', 'string'] },
    version: { type: 'integer' },
    versionNote: { type: ['null', 'string'] },
  },
  required: [
    'id',
    'creatorId',
    'descriptionHtml',
    'descriptionText',
    'label',
    'sectionTemplates',
    'slug',
    'status',
    'updatedAt',
    'updatedBy',
    'version',
  ],
} as const;

const schemaTyped = toTypedRxJsonSchema(questionnaireTemplateSchemaLiteral);

export type RxQuestionnaireTemplateDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const questionnaireTemplateSchema: RxJsonSchema<RxQuestionnaireTemplateDocType> = questionnaireTemplateSchemaLiteral;
